import { Spinner } from "@adfenix/alexandria";
import { useV4OrderRedirect } from "hooks/useV4OrderRedirect";

export const V3Order = ({ pageMode }: { pageMode: "customer" | "ap" }) => {
  useV4OrderRedirect(pageMode);
  return <Spinner centered />;
};
